import React from "react";
import { Link } from 'gatsby';
import Img from 'gatsby-image';
import * as styles from './product-slider.module.scss';
import { useUrl } from '../../../hooks/layout/useUrl';
import { useWindowSize } from "react-use";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import "swiper/css/navigation";
import "swiper/css/pagination";

import { Navigation, Pagination } from "swiper";
import { useLocalPath } from "../../../hooks";

const ProductSlider = ({
    productArray,
    title,
    displayButton,
    extraClass
}: {
    productArray: Array<{}>,
    title?: String,
    displayButton?: Boolean,
    extraClass?: any
}) => {

    const option = {
        spaceBetween: 20,
        loop: productArray && productArray.length > 3 ? true : false,
        centeredSlides: true,
        slidesPerGroupSkip: 1,
        grabCursor: true,
        keyboard: {
            enabled: true
        },
        pagination: {
            clickable: true
        },
        navigation: true,
        modules: [Navigation],
        slidesPerView: 1,
    }
    const baseUrl = useUrl();
    const { width: windowWidth } = useWindowSize()
    return (
        <div>
            {windowWidth > 680 ?
                <div className={`${styles[extraClass]}`}>
                    <h2 className={styles.h2}>{title}</h2>
                    <div className={`${styles.grid_col_3}`}>
                        {productArray?.map((data: any, index: number) => {
                            const { title, slug, thumbnailImage } = data;
                            return (

                                <div key={index} className={`${styles.col} ${styles.productCard}`}>
                                    <Link to={useLocalPath(`/${slug}`)} >
                                        <Img
                                            alt={thumbnailImage.title}
                                            fluid={thumbnailImage.fluid}
                                        ></Img>
                                        <p>{title}</p>
                                    </Link>
                                    {displayButton &&
                                        <Link to={useLocalPath(`/${slug}`)}>
                                            <button>Shop Now</button>
                                        </Link>
                                    }
                                </div>
                            )
                        })}
                    </div>
                </div>
                :
                <div>
                    <h3 className={styles.categoryTitle}>{title}</h3>
                    <div className={`${styles.grid_col_3}`}>
                        <Swiper {...option}>
                            {productArray?.map((data: any, index: number) => {
                                const { title, slug, thumbnailImage } = data;
                                return (
                                    <SwiperSlide key={index}>

                                        <div className={`${styles.col} ${styles.productCard}`}>
                                            <Link to={useLocalPath(`/${slug}`)} >
                                                <Img
                                                    alt={thumbnailImage.title}
                                                    fluid={thumbnailImage.fluid}
                                                ></Img>
                                                <p>{title}</p>
                                            </Link>
                                            {displayButton &&
                                                <Link to={useLocalPath(`/${slug}`)}>
                                                    <button>Shop Now</button>
                                                </Link>
                                            }
                                        </div>
                                    </SwiperSlide>
                                )
                            })}
                        </Swiper>
                    </div>
                </div>
            }
        </div>

    )

}

export default ProductSlider;